var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBells(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64224 18.3538C4.78636 19.3065 5.47768 20.1305 6.46789 20.3959C7.4581 20.6612 8.46881 20.2932 9.06997 19.5402L4.64224 18.3538Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4277 18.3538C19.2836 19.3065 18.5923 20.1305 17.6021 20.3959C16.6119 20.6612 15.6012 20.2932 15 19.5402L19.4277 18.3538Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9819 4.03034C13.4585 3.90771 13.9451 4.16788 14.0689 4.61146L14.0866 4.67485C16.7861 4.39261 19.3504 5.97336 20.0538 8.49456L20.8469 11.3373C21.0176 11.9491 21.3492 12.5092 21.8117 12.9672L22.5214 13.6699C23.4409 14.5804 22.9707 16.094 21.664 16.4302L11.9187 18.938C10.612 19.2743 9.41685 18.1892 9.73914 16.9592L9.9879 16.0098C10.15 15.3911 10.1455 14.7469 9.97482 14.1351L9.18169 11.2923C8.47827 8.77112 9.876 6.17081 12.3608 5.11894L12.3431 5.05555C12.2194 4.61197 12.5054 4.15297 12.9819 4.03034Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2267 17.9461C8.14855 17.5233 8.16118 17.0635 8.28813 16.579L8.53689 15.6296C8.63214 15.2661 8.62877 14.8922 8.53001 14.5382L7.73687 11.6954C6.89833 8.68992 8.34066 5.69217 10.9122 4.17308C10.9285 4.1208 10.9467 4.06927 10.9666 4.01858C10.507 3.92666 10.0504 4.18384 9.93112 4.61146L9.91343 4.67485C7.21388 4.39261 4.64961 5.97336 3.94619 8.49456L3.15305 11.3373C2.98236 11.9491 2.65083 12.5092 2.18833 12.9672L1.47862 13.6699C0.559133 14.5804 1.02926 16.094 2.33599 16.4302L8.2267 17.9461Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBells);
export default __webpack_public_path__ + "static/media/bells.e07c5705111325c50e60b113cee0b7ef.svg";
export { ForwardRef as ReactComponent };